define('view/controller/gdpr-report/GdprReportConfirmationView',['require','view/module/GdprReportView'],function (require) {

    var GdprReportView = require('view/module/GdprReportView');

    /**
     * @class GdprReportConfirmationView
     */
    return GdprReportView.extend({

        template: '#gdpr_report_confirmation',

        onCloseForm : function () {
            return false;
        },

        onAuthorized : function () {
            if (this.model.get('result')){
                this.triggerMethod('code_confirmed');
            }
        },

        serializeData: function () {
            var result = GdprReportView.prototype.serializeData.apply(this);

            if (result.data.preset) {
                result.show_email_input = false;
                if (result.errors) {
                    if (result.errors.email) {
                        result.errors.global_form = result.errors.email;
                        result.errors.email = undefined;
                    } else if (result.errors.phone) {
                        result.errors.global_form = result.errors.phone;
                        result.errors.phone = undefined;
                    }
                }
            }
            
            return result;
        },
        
        onSubmitAgain : function(){
            if (this.model.get('preset')) {
                this.sendCounter++;
                this._submit({});
                return false;
            }
            
            return GdprReportView.prototype.onSubmitAgain.apply(this, arguments);
        },

    });

});

